export default __webpack_public_path__ + "static/media/confusionImg_1.c4b72144.png";